<template>
  <tela-component :title="`${$route.params.nome}`">
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>

    <template v-else>
      <btn-manut-cad-pro
        :cliente="{ matricula: $route.params.id, nome: $route.params.nome }"        
      />
      <v-alert v-if="cadpros.length == 0" text type="info" class="mt-3"
        >Nenhum cadpro encontrado</v-alert
      >

      <v-card
        v-else
        v-for="(cadpro, i) in cadpros"
        :key="i"
        flat
        class="mt-3"
        rounded="lg"
      >
        <v-card-title class="subtitle-1">{{ cadpro.cidade }}</v-card-title>
        <v-card-subtitle>{{ cadpro.descricao }}</v-card-subtitle>
        <v-card-text>
          <p class="mb-1">
            Cadpro <span class="float-right">{{ cadpro.nrcadpro }}</span>
          </p>
          <p class="mb-1">
            Endereço <span class="float-right">{{ cadpro.endereco }}</span>
          </p>
          <p class="mb-1">
            Emissão
            <span class="float-right">{{ formatarData(cadpro.emissao) }}</span>
          </p>
          <p class="mb-1">
            Vcto
            <span class="float-right">{{ formatarData(cadpro.vcto) }}</span>
          </p>
          <p class="mb-1">
            Incra <span class="float-right">{{ cadpro.incra }}</span>
          </p>
          <p class="mb-1">
            Bairro <span class="float-right">{{ cadpro.bairro }}</span>
          </p>
          <p class="mb-1">
            CEP <span class="float-right">{{ cadpro.cep }}</span>
          </p>
          <p class="mb-1">
            Status
            <span class="float-right">
              <v-chip x-small v-if="cadpro.status == 0" color="success">{{
                cadpro.descstatus
              }}</v-chip>
              <v-chip x-small v-else color="error">{{
                cadpro.descstatus
              }}</v-chip>
            </span>
          </p>
        </v-card-text>
        <v-card-actions>
          <btn-manut-cad-pro
            :cliente="{ matricula: $route.params.id, nome: $route.params.nome }"
            :cadpro="cadpro"
          />
        </v-card-actions>
      </v-card>
    </template>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import { mapActions, mapState } from "vuex";
import moment from "moment";
import BtnManutCadPro from "@/components/cadpro/BtnManutCadPro.vue";
export default {
  components: { TelaComponent, BtnManutCadPro },
  computed: mapState("clientes", ["cadpros"]),
  data: () => ({
    loading: true,
  }),
  methods: {
    ...mapActions("clientes", ["getCadpros"]),    
    formatarData(value) {
      if (value) return moment(value).format("DD/MM/yyyy");

      return "";
    },
  },    
  async mounted() {
    this.loading = true;
    await this.getCadpros({ pesquisa: this.$route.params.id });
    this.loading = false;
  },
};
</script>

<style>
</style>